import { Brand, createBranded } from '@deltasierra/type-utilities';

export type OptOutEmailId = Brand<number, 'OptOutEmailId'>;
export const OptOutEmailId = createBranded<OptOutEmailId>();
